<template>
	<div class="col-12 bank-accounts-page">
		<div class="card card-outline card-navy">
			<div class="card-header">
				<h3 class="card-title">Cuentas de Bancos</h3>

				<div class="card-tools">
					<button @click="downloadExcel()" v-can="'add_buildings'"
						class="btn btn-sm btn-outline-success mr-1">
						<i class="fa-solid fa-file-excel"></i> Excel
					</button>

					<button @click="newDepartment()" v-can="'add_bank_accounts'" class="btn btn-sm btn-outline-info">
						<i class="fa fa-plus"></i> Cuenta
					</button>

				</div>
			</div>

			<div class="card-body">
				<div class="row align-items-end">
					<div class="col-md-6">
						<label>Buscar :</label>
						<input type="text" class="form-control" v-model="search.name" @keyup="listWithDelay()"
							placeholder="Buscar por nombre, número, banco o titular" />
					</div>

					<div class="col-md-6 text-md-right mt-3 mt-md-0">
						<label class="d-block">&nbsp;</label>

						<div class="btn-group view-toggle">
							<button type="button" class="btn btn-sm"
								:class="view_mode === 'list' ? 'btn-primary' : 'btn-outline-primary'"
								@click="changeView('list')">
								<i class="fa fa-list"></i> Vista lista
							</button>

							<button type="button" class="btn btn-sm"
								:class="view_mode === 'grouped' ? 'btn-primary' : 'btn-outline-primary'"
								@click="changeView('grouped')">
								<i class="fa fa-layer-group"></i> Vista agrupada
							</button>

							<button @click="newDepartmentGroup()" v-can="'add_bank_accounts'"
								class="btn btn-sm btn-outline-info">
								<i class="fa fa-plus"></i> Grupo
							</button>
						</div>
					</div>
				</div>

				<br>

				<div v-if="loading" class="text-center p-4">
					<i class="fa fa-spinner fa-spin"></i> Cargando cuentas...
				</div>

				<div v-else>
					<!-- ========================= -->
					<!-- VISTA LISTA -->
					<!-- ========================= -->
					<div v-if="view_mode === 'list'" class="table-responsive">
						<table class="table table-bordered text-center text-sm">
							<thead>
								<tr>
									<th>ID</th>
									<th>Nombre</th>
									<th>Número</th>
									<th>No. Cta. Clave</th>
									<th>Tipo</th>
									<th>Banco</th>
									<th>Opciones</th>
								</tr>
							</thead>

							<tbody v-if="bank_accounts && bank_accounts.length > 0">
								<tr v-for="(account, index) in bank_accounts" :key="index">
									<td>{{ account.id }}</td>

									<td>

										<span>
											{{ account.name }}
										</span>
									</td>


									<td>
										<span v-if="account.number">
											{{ maskAccount(account.number) }}
										</span>

										<span v-else class="text-muted">
											S/N
										</span>
									</td>

									<td>
										<span v-if="account.number_bis">
											{{ maskAccount(account.number_bis) }}
										</span>

										<span v-else class="text-muted">
											S/N
										</span>
									</td>

									<td>
										<span v-if="account.type_account_bank">
											{{ account.type_account_bank.name }}
										</span>

										<span v-else>
											Sin tipo
										</span>
									</td>

									<td>
										<span v-if="account.bank">
											{{ account.bank.name }}
										</span>

										<span v-else>
											Sin banco
										</span>
									</td>


									<td>
										<a :href="`${globalUrlFiles}${account.file}`"
											v-if="account.file != '' && account.file != null" target="_blank"
											class="btn btn-sm btn-outline-info m-1">
											<i class="fa-regular fa-file-pdf"></i> Carátula
										</a>

										<button @click="newDepartment(account)" v-can="'edit_bank_accounts'"
											class="btn m-1 btn-outline-primary btn-sm">
											<i class="fas fa-edit"></i> Editar
										</button>

										<button type="button" @click="deleted(account.id)"
											v-can="'deleted_bank_accounts'" class="btn-outline-danger btn m-1 btn-sm">
											<i class="fa fa-trash"></i> Eliminar
										</button>
									</td>
								</tr>
							</tbody>

							<tbody v-else>
								<tr>
									<td align="center" colspan="10">Sin resultados.</td>
								</tr>
							</tbody>
						</table>

						<pagination v-if="showPagination" v-model="page" :records="pagination.total"
							:per-page="pagination.per_page" @paginate="list" />
					</div>

					<!-- ========================= -->
					<!-- VISTA AGRUPADA PREMIUM -->
					<!-- ========================= -->
					<div v-if="view_mode === 'grouped'" class="grouped-wrapper">
						<div v-if="account_groups.length === 0" class="empty-state">
							<div class="empty-icon">
								<i class="fa fa-university"></i>
							</div>

							<h5>No se encontraron grupos de cuentas</h5>
							<p>Intenta cambiar la búsqueda o agrega una nueva cuenta bancaria.</p>
						</div>

						<div v-for="(group) in account_groups" :key="group.id" class="bank-group-card">
							<div class="bank-group-header" @click="toggleGroup(group.id)">
								<div class="group-main-info">
									<div class="group-icon">
										<i class="fa fa-building"></i>
									</div>

									<div class="group-text">
										<div class="group-title-row">
											<i class="fa toggle-icon"
												:class="isOpen(group.id) ? 'fa-chevron-down' : 'fa-chevron-right'"></i>

											<h5 class="group-title">
												{{ group.name }}
											</h5>

											<span v-if="group.alias" class="soft-badge">
												{{ group.alias }}
											</span>
										</div>

										<div class="group-subtitle">
											<span>
												<i class="fa fa-credit-card"></i>
												{{ group.accounts_count || getAccountsCount(group) }} cuenta(s)
											</span>

											<span v-if="group.banks_summary">
												<i class="fa fa-university"></i>
												{{ group.banks_summary }}
											</span>
										</div>
									</div>
								</div>

								<div class="group-actions" @click.stop>
									<!-- <span class="status-pill"
										:class="group.is_active ? 'status-active' : 'status-inactive'">
										{{ group.is_active ? 'Activo' : 'Inactivo' }}
									</span> -->

									<button type="button" class="btn btn-sm btn-outline-primary rounded-pill" @click="newDepartmentGroup(group)" v-if="group.id !== 'without_group'">
										<i class="fa fa-pencil"></i> Editar
									</button>

									<button type="button" class="btn btn-sm btn-outline-info rounded-pill"
										v-can="'add_bank_accounts'" @click="newDepartmentFromGroup(group)">
										<i class="fa fa-plus"></i> Cuenta
									</button>

									<button type="button" class="btn btn-sm btn-outline-danger rounded-pill"
										v-can="'deleted_bank_accounts'" @click="deletedGroup(group)">
										<i class="fa fa-trash"></i> Grupo
									</button>
								</div>
							</div>

							<div v-show="isOpen(group.id)" class="bank-group-body">
								<div v-if="!group.accounts || group.accounts.length === 0" class="group-empty-account">
									<i class="fa fa-credit-card"></i>
									<span>Este titular todavía no tiene cuentas registradas.</span>

									<button type="button" class="btn btn-sm btn-primary rounded-pill"
										v-can="'add_bank_accounts'" @click="newDepartmentFromGroup(group)">
										Agregar cuenta
									</button>
								</div>

								<div v-else class="accounts-grid">
									<div v-for="(account, accountIndex) in group.accounts" :key="accountIndex"
										class="account-card">
										<div class="account-top">
											<div class="bank-logo-mini">
												<i class="fa fa-university"></i>
											</div>

											<div class="account-bank-info">
												<h6>
													{{ getBankName(account) }}
												</h6>

												<span>
													{{ account.name }}
												</span>
											</div>

											<!-- <span v-if="account.is_primary" class="primary-pill">
												Principal
											</span> -->
										</div>

										<div class="account-number-box">
											<label>Número de cuenta</label>

											<div class="account-number">
												{{ account.number ? maskAccount(account.number) : 'S/N' }}
											</div>
										</div>

										<div class="account-meta">
											<div>
												<label>No. Cta. Clave</label>
												<strong>
													{{ account.number_bis ? maskAccount(account.number_bis) : 'S/N' }}
												</strong>
											</div>

											<div>
												<label>Tipo</label>
												<span v-if="account.type_account">
													{{ account.type_account }}
												</span>

												<span v-else>
													Sin tipo
												</span>
											</div>
										</div>

										<div class="account-actions">
											<a :href="`${globalUrlFiles}${account.file}`"
												v-if="account.file != '' && account.file != null" target="_blank"
												class="btn btn-sm btn-outline-info">
												<i class="fa-regular fa-file-pdf"></i>
												Carátula
											</a>

											<!-- <button
												v-if="!account.is_primary"
												type="button"
												class="btn btn-sm btn-outline-success"
												@click="setPrimary(account)"
												v-can="'edit_bank_accounts'"
											>
												<i class="fa fa-star"></i>
												Principal
											</button> -->

											<button @click="newDepartment(account)" v-can="'edit_bank_accounts'"
												class="btn btn-sm btn-outline-primary">
												<i class="fas fa-edit"></i>
												Editar
											</button>

											<button type="button" @click="deleted(account.id)"
												v-can="'deleted_bank_accounts'" class="btn btn-sm btn-outline-danger">
												<i class="fa fa-trash"></i>
												Eliminar
											</button>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

				</div>
			</div>
		</div>

		<ModalFormComponent />
		<ModalGroupComponent />
	</div>
</template>

<script>
import { mapMutations, mapActions } from 'vuex';
import request from '@/services/request';
import ModalFormComponent from '@/components/bank_accounts/ModalFormComponent.vue';
import ModalGroupComponent from '@/components/bank_accounts/ModalGroupComponent.vue';
import Pagination from 'vue-pagination-2';

export default {
	components: {
		ModalFormComponent,
		ModalGroupComponent,
		Pagination
	},

	name: "bank_accounts-table",

	data() {
		return {
			view_mode: 'grouped',

			bank_accounts: [],
			account_groups: [],

			search: {
				name: ''
			},

			page: 1,

			pagination: {
				total: 0,
				per_page: 10,
			},

			opened_groups: [],
			loading: false,
			timer: null,
			errors: {},
		}
	},

	computed: {
		showPagination() {
			return this.pagination.total > 0 && this.pagination.per_page > 0;
		}
	},

	mounted() {
		const savedViewMode = localStorage.getItem('bank_accounts_view_mode');

		if (savedViewMode) {
			this.view_mode = savedViewMode;
		}

		this.reloadCurrentView();
		this.setHeaderTitle('Cuentas de Bancos');
	},

	created() {
		Event.$on("event-load-bank_accounts", () => {
			this.reloadCurrentView();
		});
	},

	beforeDestroy() {
		Event.$off("event-load-bank_accounts");
	},

	methods: {
		newDepartmentGroup( group = {}) {
			Event.$emit('event-show-bank-account-group', group);
		},
		canDeleteGroup(group) {
			let count = group.accounts_count || this.getAccountsCount(group);

			return Number(count) === 0;
		},

		deletedGroup(group) {
			if (!this.canDeleteGroup(group)) {
				this.$swal({
					title: 'No se puede eliminar',
					text: 'Este grupo tiene cuentas relacionadas. Primero mueve las cuentas a otro grupo o elimínalas.',
					icon: 'warning',
					confirmButtonText: 'Entendido'
				});

				return;
			}

			this.$swal({
				title: 'Eliminar grupo',
				text: '¿Seguro que quieres eliminar este grupo de cuentas?',
				icon: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Sí, eliminar',
				cancelButtonText: 'Cancelar'
			}).then((result) => {
				if (result.isConfirmed) {
					this.callDeletedGroup(group.id);
				}
			});
		},

		async callDeletedGroup(id) {
			let _endpoint = '/bank_account_groups/' + id;

			try {
				let response = await request.destroy(_endpoint).then(function (response) {
					return response;
				});

				this.listGrouped();
				this.successNotification(response.data.message);
			} catch (error) {
				this.errors = await this.errorNotification(error);
			}
		},
		changeView(mode) {
			this.view_mode = mode;
			this.page = 1;

			localStorage.setItem('bank_accounts_view_mode', mode);

			this.reloadCurrentView();
		},

		reloadCurrentView() {
			if (this.view_mode === 'grouped') {
				this.listGrouped();
				return;
			}

			this.list();
		},

		downloadExcel() {
			let data = new URLSearchParams(this.search).toString();
			let url = this.globalUrlFiles + '/bank_accounts/export?' + data;

			window.open(url, '_blank');
		},

		newDepartment(account = {}) {
			Event.$emit('event-show-addContBanck', account);
		},

		newDepartmentFromGroup(group) {
			Event.$emit('event-show-addContBanck', {
				id: '',
				bank_account_group_id: group.id,
				name: group.name,
				alias: '',
				number: '',
				type_account: '',
				bank_id: '',
				number_bis: '',
				file: '',
				is_primary: false,
				is_active: true,
			});
		},

		toggleGroup(groupId) {
			if (this.isOpen(groupId)) {
				this.opened_groups = this.opened_groups.filter(id => id !== groupId);
				return;
			}

			this.opened_groups.push(groupId);
		},

		isOpen(groupId) {
			return this.opened_groups.includes(groupId);
		},

		getAccountsCount(group) {
			if (!group.accounts) {
				return 0;
			}

			return group.accounts.length;
		},

		maskAccount(value) {


			return value;
		},

		getBankName(account) {
			if (account.bank && account.bank.name) {
				return account.bank.name;
			}

			if (account.bank_name) {
				return account.bank_name;
			}

			return 'Sin banco';
		},

		getTypeName(account) {
			if (account.type_account_bank && account.type_account_bank.name) {
				return account.type_account_bank.name;
			}

			if (account.type_account_name) {
				return account.type_account_name;
			}

			return 'Sin tipo';
		},

		listWithDelay() {
			clearTimeout(this.timer);

			this.timer = setTimeout(() => {
				this.page = 1;
				this.reloadCurrentView();
			}, 400);
		},

		deleted(id) {
			let tit = 'Eliminar Cuenta';
			let txt = 'Seguro que quiere eliminar la cuenta';

			this.$swal({
				title: tit,
				text: txt,
				icon: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Ok',
				cancelButtonText: 'Cancelar'
			}).then((result) => {
				if (result.isConfirmed) {
					this.callDeleted(id);
				}
			});
		},

		async callDeleted(id) {
			let _endpoint = '/bank_accounts/' + id;

			try {
				let response = await request.destroy(_endpoint).then(function (response) {
					return response;
				});

				this.reloadCurrentView();
				this.successNotification(response.data.message);
			} catch (error) {
				this.errors = await this.errorNotification(error);
			}
		},

		setPrimary(account) {
			this.$swal({
				title: 'Cuenta principal',
				text: '¿Deseas marcar esta cuenta como principal?',
				icon: 'question',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Sí, marcar',
				cancelButtonText: 'Cancelar'
			}).then((result) => {
				if (result.isConfirmed) {
					this.callSetPrimary(account.id);
				}
			});
		},

		async callSetPrimary(id) {
			let _endpoint = '/bank_accounts/' + id + '/set-primary';

			try {
				let response = await request.put(_endpoint, {}).then(function (response) {
					return response;
				});

				this.reloadCurrentView();
				this.successNotification(response.data.message);
			} catch (error) {
				this.errors = await this.errorNotification(error);
			}
		},

		async list(page = 1) {
			this.loading = true;
			this.page = page;

			let service = request;
			let search = this.search;
			let _endpoint = '/bank_accounts';

			try {
				let { data } = await service.list(_endpoint, page, search);

				if (data) {
					if (Array.isArray(data)) {
						this.bank_accounts = data;
						this.pagination.total = 0;
						this.pagination.per_page = 10;
					} else {
						this.bank_accounts = data.data ? data.data : [];
						this.pagination.total = data.total ? data.total : 0;
						this.pagination.per_page = data.per_page ? data.per_page : 10;
					}
				}
			} catch (error) {
				console.log(error);
				this.errorNotification(error);
			} finally {
				this.loading = false;
			}
		},

		async listGrouped() {
			this.loading = true;

			let service = request;
			let search = this.search;
			let _endpoint = '/bank_account_groups';

			try {
				let { data } = await service.list(_endpoint, 1, search);

				if (data) {
					this.account_groups = data.data ? data.data : data;

					if (this.account_groups.length > 0 && this.opened_groups.length === 0) {
						this.opened_groups.push(this.account_groups[0].id);
					}
				}
			} catch (error) {
				console.log(error);
				this.errorNotification(error);
			} finally {
				this.loading = false;
			}
		},

		...mapMutations({
			setHeaderTitle: 'setHeaderTitle',
		}),

		...mapActions({
			resetPassword: 'auth/resetPass',
			errorNotification: 'alert/error',
			successNotification: 'alert/success',
		}),
	}
}
</script>

<style scoped>
.bank-accounts-page {
	font-size: 14px;
}

.view-toggle .btn {
	border-radius: 20px;
	margin-left: 4px;
}

.table td,
.table th {
	vertical-align: middle;
}

.pagination {
	margin-bottom: 0;
}

/* ========================= */
/* VISTA AGRUPADA PREMIUM */
/* ========================= */

.grouped-wrapper {
	display: flex;
	flex-direction: column;
	gap: 16px;
}

.bank-group-card {
	background: #ffffff;
	border: 1px solid #e8edf3;
	border-radius: 16px;
	box-shadow: 0 10px 24px rgba(15, 23, 42, 0.08);
	overflow: hidden;
	transition: all 0.2s ease;
}

.bank-group-card:hover {
	transform: translateY(-1px);
	box-shadow: 0 14px 30px rgba(15, 23, 42, 0.12);
}

.bank-group-header {
	padding: 18px 20px;
	background: linear-gradient(135deg, #f8fbff 0%, #ffffff 55%, #f3f8ff 100%);
	display: flex;
	align-items: center;
	justify-content: space-between;
	cursor: pointer;
	border-left: 5px solid #0d6efd;
}

.group-main-info {
	display: flex;
	align-items: center;
	gap: 14px;
	min-width: 0;
}

.group-icon {
	width: 42px;
	height: 42px;
	border-radius: 14px;
	background: #eaf3ff;
	color: #0d6efd;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 17px;
	flex-shrink: 0;
}

.group-text {
	min-width: 0;
}

.group-title-row {
	display: flex;
	align-items: center;
	gap: 8px;
	flex-wrap: wrap;
}

.toggle-icon {
	color: #334155;
	font-size: 13px;
}

.group-title {
	margin: 0;
	font-size: 15px;
	font-weight: 800;
	color: #1f2937;
	letter-spacing: 0.2px;
}

.group-subtitle {
	margin-top: 6px;
	display: flex;
	gap: 14px;
	flex-wrap: wrap;
	font-size: 12px;
	color: #64748b;
}

.group-subtitle i {
	margin-right: 4px;
	color: #0d6efd;
}

.group-actions {
	display: flex;
	align-items: center;
	gap: 8px;
	flex-shrink: 0;
}

.soft-badge {
	background: #f1f5f9;
	color: #334155;
	border: 1px solid #e2e8f0;
	border-radius: 999px;
	font-size: 11px;
	padding: 4px 9px;
	font-weight: 600;
}

.status-pill,
.status-pill-mini {
	border-radius: 999px;
	font-size: 11px;
	font-weight: 700;
	padding: 5px 10px;
	display: inline-flex;
	align-items: center;
	justify-content: center;
}

.status-pill-mini {
	padding: 4px 8px;
}

.status-active {
	background: #dcfce7;
	color: #15803d;
}

.status-inactive {
	background: #e5e7eb;
	color: #4b5563;
}

.bank-group-body {
	padding: 18px;
	background: #fbfdff;
	border-top: 1px solid #e8edf3;
}

.accounts-grid {
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(310px, 1fr));
	gap: 14px;
}

.account-card {
	background: #ffffff;
	border: 1px solid #e5eaf0;
	border-radius: 14px;
	padding: 16px;
	position: relative;
	transition: all 0.2s ease;
	box-shadow: 0 4px 14px rgba(15, 23, 42, 0.05);
}

.account-card:hover {
	border-color: #bfdbfe;
	box-shadow: 0 10px 24px rgba(15, 23, 42, 0.10);
}

.account-card-primary {
	border-color: #22c55e;
	background: linear-gradient(180deg, #ffffff 0%, #f7fff9 100%);
}

.account-top {
	display: flex;
	align-items: center;
	gap: 10px;
	margin-bottom: 14px;
}

.bank-logo-mini {
	width: 38px;
	height: 38px;
	border-radius: 12px;
	background: #f1f5f9;
	color: #334155;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
}

.account-bank-info {
	min-width: 0;
	flex: 1;
}

.account-bank-info h6 {
	margin: 0;
	font-size: 14px;
	font-weight: 800;
	color: #1f2937;
}

.account-bank-info span {
	font-size: 12px;
	color: #64748b;
}

.primary-pill {
	background: #dcfce7;
	color: #15803d;
	border-radius: 999px;
	font-size: 11px;
	font-weight: 800;
	padding: 5px 9px;
}

.account-number-box {
	background: #f8fafc;
	border: 1px dashed #cbd5e1;
	border-radius: 12px;
	padding: 12px;
	margin-bottom: 14px;
}

.account-number-box label,
.account-meta label {
	display: block;
	margin-bottom: 4px;
	font-size: 11px;
	color: #64748b;
	font-weight: 700;
	text-transform: uppercase;
}

.account-number {
	font-size: 20px;
	font-weight: 900;
	color: #0f172a;
	letter-spacing: 1px;
}

.account-meta {
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 10px;
	margin-bottom: 14px;
}

.account-meta strong {
	font-size: 13px;
	color: #1f2937;
}

.account-actions {
	display: flex;
	flex-wrap: wrap;
	gap: 6px;
	border-top: 1px solid #eef2f7;
	padding-top: 12px;
}

.group-empty-account {
	border: 1px dashed #cbd5e1;
	border-radius: 14px;
	padding: 20px;
	background: #ffffff;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 12px;
	color: #64748b;
}

.group-empty-account i {
	color: #0d6efd;
}

.empty-state {
	background: #ffffff;
	border-radius: 16px;
	border: 1px solid #e8edf3;
	padding: 40px 20px;
	text-align: center;
	color: #64748b;
	box-shadow: 0 8px 20px rgba(15, 23, 42, 0.06);
}

.empty-icon {
	width: 58px;
	height: 58px;
	border-radius: 18px;
	margin: 0 auto 14px auto;
	background: #eaf3ff;
	color: #0d6efd;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 22px;
}

.empty-state h5 {
	color: #1f2937;
	font-weight: 800;
	margin-bottom: 6px;
}

.btn-xs {
	padding: 2px 7px;
	font-size: 11px;
	line-height: 1.5;
	border-radius: 10px;
}

@media (max-width: 768px) {
	.bank-group-header {
		flex-direction: column;
		align-items: flex-start;
		gap: 14px;
	}

	.group-actions {
		width: 100%;
		justify-content: flex-start;
	}

	.accounts-grid {
		grid-template-columns: 1fr;
	}

	.group-empty-account {
		flex-direction: column;
		text-align: center;
	}
}
</style>